import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

// --- IMPORTS LOCAUX ---
import { AuthProvider } from "./lib/auth";
import { ThemeProvider } from "./lib/ThemeContext";
import { StreamingProvider } from "./lib/StreamingContext";

// Création du client React Query
const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {/* 1. Gestion des requêtes API */}
    <QueryClientProvider client={queryClient}>

      {/* 2. Router global */}
      <BrowserRouter>

        {/* 3. Auth (doit être sous BrowserRouter pour Navigate / useLocation) */}
        <AuthProvider>

          {/* 4. Gestion du thème (peut utiliser l’état auth ou router) */}
          <ThemeProvider>

            {/* 5. Gestion du live / streaming */}
            <StreamingProvider>

              {/* 6. App complète */}
              <App />

            </StreamingProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
